// 这部分是从 src/framework/editor/src/js/utils/index.js 挪过来的
interface Scale {
    x: number,
    y: number,
    dx?: number,
    dy?: number;
}
export function calResize(params) {
    handleParamsForCalResize(params);
    const {
        transformedRect, flipAtStart, sizeAtStart, baseIndex, offsetX, offsetY, isSameTargetSize,
    } = params;
    let scale: Scale = {
        x: 1,
        y: 1,
    };

    const points = transformedRect.point[flipAtStart.flipH][flipAtStart.flipV];

    // console.log('~_~ || ', points[baseIndex].x, points[baseIndex].y);
    const dragingPoint = points[(baseIndex + 4) % 8];
    const nex = dragingPoint.x + offsetX;
    const ney = dragingPoint.y + offsetY;

    const dist = getDistPointToLine(points, baseIndex, nex, ney);

    scale.dx = dist.dx;
    scale.dy = dist.dy;

    let targetSize = {
        ...sizeAtStart,
        ...flipAtStart,
    };

    // 计算锁定纵横比的targetSize
    const scaleNoChangeAspect = calScale(params, scale, dist);
    let targetSizeLockAspect = { ...targetSize };
    targetSizeLockAspect = getTargetSize(params, scaleNoChangeAspect, targetSizeLockAspect, dist);

    // 计算非锁定纵横比的targetSize
    if (isSameTargetSize) {
        targetSize = { ...targetSizeLockAspect };
    } else {
        params.needCalNoChangeAspectScale = false;
        scale = calScale(params, scale, dist);
        targetSize = getTargetSize(params, scale, targetSize, dist);
    }

    // 同时返回不锁定纵横比和锁定纵横比的size
    return { targetSize, targetSizeLockAspect };
}
/**
* 处理传入calResize的参数
*/
function handleParamsForCalResize(params) {
    const { isCroping, e } = params;
    params.needCalNoChangeAspectScale = !isCroping; // 裁剪不需要计算锁定纵横比
    params.isSameTargetSize = e.shiftKey; // 当按住shiftKey时，元素计算锁定纵横比
}
// /获取旋转顶点到当前点的垂直距离，及其方向(判断翻转问题)
export function getDistPointToLine(point, baseIndex, nex, ney) {
    const bX = point[baseIndex].x;
    const bY = point[baseIndex].y;

    let dx = 0;
    let dy = 0;
    let directV = 0;
    let directH = 0;

    /*
  点到线段的距离 + 点在线段的方向

  d=abs((x1-x0)(y2-y0)-(x2-x0)(y1-y0))/sqrt((x1-x2)^2+(y1-y2)^2);

  S(A,B,C)=|y1 y2 y3|= (x1-x3)*(y2-y3)-(y1-y3)*(x2-x3)
  当ABC逆时针时S为正的，当ABC顺时针时S为负的。
  令矢量的起点为A，终点为B，判断的点为C，
  如果S（A，B，C）为正数，则C在矢量AB的左侧；
  如果S（A，B，C）为负数，则C在矢量AB的右侧；
  如果S（A，B，C）为0，则C在直线AB上。
  */
    if (baseIndex === 0) {  // /四个顶点
        const referX1 = point[1].x;
        const referY1 = point[1].y;
        dy = Math.abs(((bX - nex) * (referY1 - ney)) - ((referX1 - nex) * (bY - ney)))
      / Math.sqrt(((bX - referX1) * (bX - referX1)) + ((bY - referY1) * (bY - referY1)));
        directV = ((bX - nex) * (referY1 - ney)) - ((bY - ney) * (referX1 - nex));
        const referX2 = point[7].x;
        const referY2 = point[7].y;
        dx = Math.abs(((bX - nex) * (referY2 - ney)) - ((referX2 - nex) * (bY - ney)))
      / Math.sqrt(((bX - referX2) * (bX - referX2)) + ((bY - referY2) * (bY - referY2)));
        directH = ((referX2 - nex) * (bY - ney)) - ((referY2 - ney) * (bX - nex));
    } else if (baseIndex === 4) {
        const referX1 = point[5].x;
        const referY1 = point[5].y;
        dy = Math.abs(((bX - nex) * (referY1 - ney)) - ((referX1 - nex) * (bY - ney)))
      / Math.sqrt(((bX - referX1) * (bX - referX1)) + ((bY - referY1) * (bY - referY1)));
        directV = ((bX - nex) * (referY1 - ney)) - ((bY - ney) * (referX1 - nex));
        const referX2 = point[3].x;
        const referY2 = point[3].y;
        dx = Math.abs(((bX - nex) * (referY2 - ney)) - ((referX2 - nex) * (bY - ney)))
      / Math.sqrt(((bX - referX2) * (bX - referX2)) + ((bY - referY2) * (bY - referY2)));
        directH = ((referX2 - nex) * (bY - ney)) - ((referY2 - ney) * (bX - nex));
    } else if ([2, 6].indexOf(baseIndex) >= 0) {
        const referX1 = point[baseIndex + 1].x;
        const referY1 = point[baseIndex + 1].y;
        dx = Math.abs(((bX - nex) * (referY1 - ney)) - ((referX1 - nex) * (bY - ney)))
      / Math.sqrt(((bX - referX1) * (bX - referX1)) + ((bY - referY1) * (bY - referY1)));
        directH = ((bX - nex) * (referY1 - ney)) - ((bY - ney) * (referX1 - nex));
        const referX2 = point[baseIndex - 1].x;
        const referY2 = point[baseIndex - 1].y;
        dy = Math.abs(((bX - nex) * (referY2 - ney)) - ((referX2 - nex) * (bY - ney)))
      / Math.sqrt(((bX - referX2) * (bX - referX2)) + ((bY - referY2) * (bY - referY2)));
        directV = ((referX2 - nex) * (bY - ney)) - ((referY2 - ney) * (bX - nex));
    } else if ([1, 5].indexOf(baseIndex) >= 0) {
        const referX = point[baseIndex - 1].x;
        const referY = point[baseIndex - 1].y;
        dy = Math.abs(((bX - nex) * (referY - ney)) - ((referX - nex) * (bY - ney)))
      / Math.sqrt(((bX - referX) * (bX - referX)) + ((bY - referY) * (bY - referY)));
        directV = ((referX - nex) * (bY - ney)) - ((referY - ney) * (bX - nex));
    } else if ([3, 7].indexOf(baseIndex) >= 0) {
        const referX = point[baseIndex - 1].x;
        const referY = point[baseIndex - 1].y;
        dx = Math.abs(((bX - nex) * (referY - ney)) - ((referX - nex) * (bY - ney)))
      / Math.sqrt(((bX - referX) * (bX - referX)) + ((bY - referY) * (bY - referY)));
        directH = ((referX - nex) * (bY - ney)) - ((referY - ney) * (bX - nex));
    }

    return {
        dx,
        dy,
        directV,
        directH,
    };
}
function calScale(params, scale, dist) {
    const resultScale = {
        ...scale,
    };
    const {
        sizeAtStart, baseIndex, e, minSize, needCalNoChangeAspectScale,
    } = params;
    let newDx = dist.dx;
    let newDy = dist.dy;
    if (minSize) {
        const newD = processWithMinSize(newDx, dist, newDy);
        newDx = newD.newDx;
        newDy = newD.newDy;
    }
    if (needCalNoChangeAspectScale) {
        // 判断是否计算锁定纵横比的scale
        calNoChangeAspectScale(e, resultScale, newDx, sizeAtStart, newDy, baseIndex);
    } else if ([0, 2, 4, 6].indexOf(baseIndex) >= 0) {
        resultScale.x = newDx / sizeAtStart.width;
        resultScale.y = newDy / sizeAtStart.height;
    } else if ([1, 5].indexOf(baseIndex) >= 0) {
        resultScale.y = newDy / sizeAtStart.height;
    } else if ([3, 7].indexOf(baseIndex) >= 0) {
        resultScale.x = newDx / sizeAtStart.width;
    }
    return resultScale;
}
function processWithMinSize(newDx, dist, newDy) {
    newDx = (dist.dx < 20 || dist.directH < 0) ? 20 : dist.dx;
    newDy = (dist.dy < 20 || dist.directV < 0) ? 20 : dist.dy;
    return { newDx, newDy };
}
function calNoChangeAspectScale(e, resultScale, newDx, sizeAtStart, newDy, baseIndex) {
    if (e.shiftKey) {
        // 每个点按住shift都可以等比缩放
        resultScale.x = newDx / sizeAtStart.width;
        resultScale.y = newDy / sizeAtStart.height;
        if (resultScale.x > resultScale.y) {
            resultScale.y = resultScale.x;
        } else {
            resultScale.x = resultScale.y;
        }
    } else {
        // 不按住shift，只有四个顶点是等比缩放，其中图片默认四个定点等比缩放
        if ([0, 2, 4, 6].indexOf(baseIndex) >= 0) {
            resultScale.x = newDx / sizeAtStart.width;
            resultScale.y = newDy / sizeAtStart.height;
            if (resultScale.x > resultScale.y) {
                resultScale.y = resultScale.x;
            } else {
                resultScale.x = resultScale.y;
            }
        } else if ([1, 5].indexOf(baseIndex) >= 0) {
            resultScale.y = newDy / sizeAtStart.height;
        } else if ([3, 7].indexOf(baseIndex) >= 0) {
            resultScale.x = newDx / sizeAtStart.width;
        }
    }
}

function getTargetSize(params, scale, targetSize, dist) {
    const { flipAtStart, rotate, isIframe, baseIndex } = params;
    /* 旋转后的新rect计算（包括缩放计算、以及顶点矫正） */
    const newRect = getNewRect(params, scale);
    // console.log('~_~ |||| ', newRect.x, newRect.y);

    targetSize.left = newRect.x;
    targetSize.top = newRect.y;
    targetSize.width = newRect.width;
    targetSize.height = newRect.height;

    if (!isIframe) {
        calFlip(flipAtStart, dist, targetSize);
    }

    targetSize = calTargetSize(targetSize, flipAtStart, rotate, baseIndex);

    return targetSize;
}

/**
* 根据缩放基点和缩放比例取得新的rect
*/
export function getNewRect(params, scale) {
    const {
        sizeAtStart, transformedRect, baseIndex, rotate, flipAtStart,
    } = params;
    const scaledRect = getScaledRect({
        x: sizeAtStart.left,
        y: sizeAtStart.top,
        width: sizeAtStart.width,
        height: sizeAtStart.height,
        scale,
    });
    // let centerOffsetX = (scaledRect.width - sizeAtStart.width) / 2;
    // let centerOffsetY = (scaledRect.height - sizeAtStart.height) / 2;
    // scaledRect.centerX = sizeAtStart.centerX + centerOffsetX;
    // scaledRect.centerY = sizeAtStart.centerY + centerOffsetY;
    // var transformedRotateRect = transformWithCenterPoint(scaledRect, rotate);
    const transformedRotateRect = transform(scaledRect, rotate);
    // 计算到平移后的新坐标
    const translatedX = transformedRect.point[flipAtStart.flipH][flipAtStart.flipV][baseIndex].x
  - transformedRotateRect.point[flipAtStart.flipH][flipAtStart.flipV][baseIndex].x + transformedRotateRect.left;
    const translatedY = transformedRect.point[flipAtStart.flipH][flipAtStart.flipV][baseIndex].y
   - transformedRotateRect.point[flipAtStart.flipH][flipAtStart.flipV][baseIndex].y + transformedRotateRect.top;

    // 计算平移后元素左上角的坐标
    const newX = translatedX + (transformedRotateRect.width / 2) - (scaledRect.width / 2);
    const newY = translatedY + (transformedRotateRect.height / 2) - (scaledRect.height / 2);

    // 缩放后元素的高宽
    const newWidth = scaledRect.width;
    const newHeight = scaledRect.height;
    return {
        x: newX,
        y: newY,
        width: newWidth,
        height: newHeight,
    };
}
/**
* 取得缩放指定倍数后的坐标
*/
export function getScaledRect(params, baseIndex?) {
    const {
        x, y, width, height, scale,
    } = params;
    const offset = {
        x: 0,
        y: 0,
    };

    const deltaXScale = scale.x - 1;
    const deltaYScale = scale.y - 1;

    let deltaWidth; let deltaHeight;

    if (scale.x === Infinity) {
        deltaWidth = scale.dx;
    } else {
        deltaWidth = width * deltaXScale;
    }
    const newWidth = width + deltaWidth;

    if (scale.y === Infinity) {
        deltaHeight = scale.dy;
    } else {
        deltaHeight = height * deltaYScale;
    }
    const newHeight = height + deltaHeight;

    const newX = x - (deltaWidth / 2);
    const newY = y - (deltaHeight / 2);

    if (baseIndex) {
        const points = [{ x, y }, { x: x + width, y }, { x: x + width, y: y + height }, { x, y: y + height }];
        const newPoints = [{ x: newX, y: newY }, { x: newX + newWidth, y: newY },
            { x: newX + newWidth, y: newY + newHeight }, { x: newX, y: newY + newHeight }];
        offset.x = points[baseIndex].x - newPoints[baseIndex].x;
        offset.y = points[baseIndex].y - newPoints[baseIndex].y;
    }
    return {
        x: newX + offset.x,
        y: newY + offset.y,
        width: newWidth,
        height: newHeight,
    };
}

function calFlipV(flipAtStart, dist, targetSize) {
    if ((flipAtStart.flipH === flipAtStart.flipV && dist.directV < 0)
   || (flipAtStart.flipH !== flipAtStart.flipV && dist.directV > 0)) {
        targetSize.flipV = flipAtStart.flipV === 1 ? 0 : 1;
    }
}

function calFlip(flipAtStart, dist, targetSize) {
    /* -------------------------------缩放Flip处理--------------------------------*/
    if ((flipAtStart.flipH === flipAtStart.flipV && dist.directH < 0)
  || (flipAtStart.flipH !== flipAtStart.flipV && dist.directH > 0)) {
        targetSize.flipH = flipAtStart.flipH === 1 ? 0 : 1;
    }

    calFlipV(flipAtStart, dist, targetSize);
}

export const testObj = {
    calFlip,
    calFlipV,
};

export function transformWithCenterPoint(options, rotate) {
    const { x } = options;
    const { y } = options;
    const { width } = options;
    const { height } = options;
    const { centerX } = options;
    const { centerY } = options;
    const angle = rotate * Math.PI / 180;
    const cosValue = Math.cos(angle);
    const sinValue = Math.sin(angle);
    const halfWidth = width / 2;
    const halfHeight = height / 2;

    const topLeft = {
        x: ((x - centerX) * cosValue) - ((y - centerY) * sinValue) + centerX,
        y: ((x - centerX) * sinValue) + ((y - centerY) * cosValue) + centerY,
    };

    const top = {
        x: ((x + halfWidth - centerX) * cosValue) - ((y - centerY) * sinValue) + centerX,
        y: ((x + halfWidth - centerX) * sinValue) + ((y - centerY) * cosValue) + centerY,
    };

    const topRight = {
        x: ((x + width - centerX) * cosValue) - ((y - centerY) * sinValue) + centerX,
        y: ((x + width - centerX) * sinValue) + ((y - centerY) * cosValue) + centerY,
    };

    const right = {
        x: ((x + width - centerX) * cosValue) - ((y + halfHeight - centerY) * sinValue) + centerX,
        y: ((x + width - centerX) * sinValue) + ((y + halfHeight - centerY) * cosValue) + centerY,
    };
    const bottomRight = {
        x: ((x + width - centerX) * cosValue) - ((y + height - centerY) * sinValue) + centerX,
        y: ((x + width - centerX) * sinValue) + ((y + height - centerY) * cosValue) + centerY,
    };
    const bottom = {
        x: ((x + halfWidth - centerX) * cosValue) - ((y + height - centerY) * sinValue) + centerX,
        y: ((x + halfWidth - centerX) * sinValue) + ((y + height - centerY) * cosValue) + centerY,
    };
    const bottomLeft = {
        x: ((x - centerX) * cosValue) - ((y + height - centerY) * sinValue) + centerX,
        y: ((x - centerX) * sinValue) + ((y + height - centerY) * cosValue) + centerY,
    };
    const left = {
        x: ((x - centerX) * cosValue) - ((y + halfHeight - centerY) * sinValue) + centerX,
        y: ((x - centerX) * sinValue) + ((y + halfHeight - centerY) * cosValue) + centerY,
    };

    const minX = Math.min(topLeft.x, topRight.x, bottomRight.x, bottomLeft.x);
    const maxX = Math.max(topLeft.x, topRight.x, bottomRight.x, bottomLeft.x);
    const minY = Math.min(topLeft.y, topRight.y, bottomRight.y, bottomLeft.y);
    const maxY = Math.max(topLeft.y, topRight.y, bottomRight.y, bottomLeft.y);

    return {
        point: [[[topLeft, top, topRight, right, bottomRight, bottom, bottomLeft, left],
            [topRight, top, topLeft, left, bottomLeft, bottom, bottomRight, right]],
        [[bottomLeft, bottom, bottomRight, right, topRight, top, topLeft, left],
            [bottomRight, bottom, bottomLeft, left, topLeft, top, topRight, right]]],
        width: maxX - minX,
        height: maxY - minY,
        left: minX,
        right: maxX,
        top: minY,
        bottom: maxY,
    };
}

// /获取旋转指定角度后的rect
export function transform(options, angle) {
    const { x } = options;
    const { y } = options;
    const width = options.width ? options.width : 0.0000000000001;
    const height = options.height ? options.height : 0.0000000000001;

    const r = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2)) / 2;
    // var a = Math.round(Math.atan(height / width) * 180 / Math.PI);
    const a = Math.atan(height / width) * 180 / Math.PI;
    const tlbra = 180 - angle - a;
    const trbla = a - angle;
    const ta = 90 - angle;
    const ra = angle;

    const halfWidth = width / 2;
    const halfHeight = height / 2;

    const middleX = x + halfWidth;
    const middleY = y + halfHeight;

    const topLeft = {
        x: middleX + (r * Math.cos(tlbra * Math.PI / 180)),
        y: middleY - (r * Math.sin(tlbra * Math.PI / 180)),
    };

    const top = {
        x: middleX + (halfHeight * Math.cos(ta * Math.PI / 180)),
        y: middleY - (halfHeight * Math.sin(ta * Math.PI / 180)),
    };

    const topRight = {
        x: middleX + (r * Math.cos(trbla * Math.PI / 180)),
        y: middleY - (r * Math.sin(trbla * Math.PI / 180)),
    };

    const right = {
        x: middleX + (halfWidth * Math.cos(ra * Math.PI / 180)),
        y: middleY + (halfWidth * Math.sin(ra * Math.PI / 180)),
    };
    const bottomRight = {
        x: middleX - (r * Math.cos(tlbra * Math.PI / 180)),
        y: middleY + (r * Math.sin(tlbra * Math.PI / 180)),
    };
    const bottom = {
        x: middleX - (halfHeight * Math.sin(ra * Math.PI / 180)),
        y: middleY + (halfHeight * Math.cos(ra * Math.PI / 180)),
    };
    const bottomLeft = {
        x: middleX - (r * Math.cos(trbla * Math.PI / 180)),
        y: middleY + (r * Math.sin(trbla * Math.PI / 180)),
    };
    const left = {
        x: middleX - (halfWidth * Math.cos(ra * Math.PI / 180)),
        y: middleY - (halfWidth * Math.sin(ra * Math.PI / 180)),
    };

    const minX = Math.min(topLeft.x, topRight.x, bottomRight.x, bottomLeft.x);
    const maxX = Math.max(topLeft.x, topRight.x, bottomRight.x, bottomLeft.x);
    const minY = Math.min(topLeft.y, topRight.y, bottomRight.y, bottomLeft.y);
    const maxY = Math.max(topLeft.y, topRight.y, bottomRight.y, bottomLeft.y);

    return {
        point: [[[topLeft, top, topRight, right, bottomRight, bottom, bottomLeft, left],
            [topRight, top, topLeft, left, bottomLeft, bottom, bottomRight, right]],
        [[bottomLeft, bottom, bottomRight, right, topRight, top, topLeft, left],
            [bottomRight, bottom, bottomLeft, left, topLeft, top, topRight, right]]],
        width: maxX - minX,
        height: maxY - minY,
        left: minX,
        right: maxX,
        top: minY,
        bottom: maxY,
    };
}

function calTargetSize(ts, flipAtStart, rotate, baseIndex) {
    const targetSize = { ...ts };
    if (targetSize.flipH !== flipAtStart.flipH) {
        calTargetSizeFlipH(targetSize, flipAtStart, baseIndex, rotate);
    }

    if (targetSize.flipV !== flipAtStart.flipV) {
        calTargetSizeFlipV(targetSize, flipAtStart, baseIndex, rotate);
    }
    return targetSize;
}

function calTargetSizeFlipH(targetSize, flipAtStart, baseIndex, rotate) {
    // 角度转弧度
    const angle = rotate * Math.PI / 180;
    const cosValue = Math.cos(angle);
    const sinValue = Math.sin(angle);
    if (flipAtStart.flipV) {
        if ([0, 6, 7].indexOf(baseIndex) >= 0) {
            targetSize.left = targetSize.left + (targetSize.width * cosValue);
            targetSize.top = targetSize.top + (targetSize.width * sinValue);
        } else if ([2, 3, 4].indexOf(baseIndex) >= 0) {
            targetSize.left = targetSize.left - (targetSize.width * cosValue);
            targetSize.top = targetSize.top - (targetSize.width * sinValue);
        }
    } else if ([0, 6, 7].indexOf(baseIndex) >= 0) {
        targetSize.left = targetSize.left - (targetSize.width * cosValue);
        targetSize.top = targetSize.top - (targetSize.width * sinValue);
    } else if ([2, 3, 4].indexOf(baseIndex) >= 0) {
        targetSize.left = targetSize.left + (targetSize.width * cosValue);
        targetSize.top = targetSize.top + (targetSize.width * sinValue);
    }
}

function calTargetSizeFlipV(targetSize, flipAtStart, baseIndex, rotate) {
    // 角度转弧度
    const angle = rotate * Math.PI / 180;
    const cosValue = Math.cos(angle);
    const sinValue = Math.sin(angle);
    if (flipAtStart.flipH) {
        if ([0, 1, 2].indexOf(baseIndex) >= 0) {
            targetSize.top = targetSize.top + (targetSize.height * cosValue);
            targetSize.left = targetSize.left - (targetSize.height * sinValue);
        } else if ([4, 5, 6].indexOf(baseIndex) >= 0) {
            targetSize.top = targetSize.top - (targetSize.height * cosValue);
            targetSize.left = targetSize.left + (targetSize.height * sinValue);
        }
    } else if ([0, 1, 2].indexOf(baseIndex) >= 0) {
        targetSize.top = targetSize.top - (targetSize.height * cosValue);
        targetSize.left = targetSize.left + (targetSize.height * sinValue);
    } else if ([4, 5, 6].indexOf(baseIndex) >= 0) {
        targetSize.top = targetSize.top + (targetSize.height * cosValue);
        targetSize.left = targetSize.left - (targetSize.height * sinValue);
    }
}

export function getBaseIndexWithMode(resizeMode, flipAtStart) {
    let baseIndex = getBaseIndex(resizeMode);

    if (flipAtStart.flipH && flipAtStart.flipV) {
        baseIndex = (baseIndex + 4) % 8;
    } else if (flipAtStart.flipH) {
        baseIndex = getFlipHBaseIndex(baseIndex);
    } else if (flipAtStart.flipV) {
        baseIndex = getFlipVBaseIndex(baseIndex);
    }
    return baseIndex;
}

function getBaseIndex(resizeMode) {
    let baseIndex = 0;
    if (resizeMode === 'RIGHT') {
        baseIndex =  7;
    } else if (resizeMode === 'TOP') {
        baseIndex =  5;
    } else if (resizeMode === 'TOP_LEFT') {
        baseIndex =  4;
    } else if (resizeMode === 'TOP_RIGHT') {
        baseIndex =  6;
    } else if (resizeMode === 'BOTTOM_RIGHT') {
        baseIndex =  0;
    } else if (resizeMode === 'BOTTOM') {
        baseIndex =  1;
    } else if (resizeMode === 'BOTTOM_LEFT') {
        baseIndex =  2;
    } else if (resizeMode === 'LEFT') {
        baseIndex =  3;
    }
    return baseIndex;
}

function getFlipHBaseIndex(bIndex) {
    let baseIndex = bIndex;
    if (baseIndex === 0) baseIndex = 6;
    else if (baseIndex === 6) baseIndex = 0;
    else if (baseIndex === 1) baseIndex = 5;
    else if (baseIndex === 5) baseIndex = 1;
    else if (baseIndex === 4) baseIndex = 2;
    else if (baseIndex === 2) baseIndex = 4;
    return baseIndex;
}

function getFlipVBaseIndex(bIndex) {
    let baseIndex = bIndex;
    if (baseIndex === 0) baseIndex = 2;
    else if (baseIndex === 2) baseIndex = 0;
    else if (baseIndex === 3) baseIndex = 7;
    else if (baseIndex === 7) baseIndex = 3;
    else if (baseIndex === 4) baseIndex = 6;
    else if (baseIndex === 6) baseIndex = 4;
    return baseIndex;
}
